import React, {useContext, useEffect, useState} from 'react'
import {moneyFormatter, validLimitDecimal} from '../../../../../../utils'
import {AdminProductContext} from '../../../../../context/AdminProductContext'
import {NumericInput} from '../../../../../shared/components/NumericInput'

type Product = {
  data?: any
  currentPage?: number
  totalPages?: number
  handleUpdateProduct: (id: any) => void
  handleSave: () => void
  editingId?: any
  editedData?: any
  handleSaveClick: () => void
  handleInputChange: (e: any) => void
  handlePrevPage: () => void
  handleNextPage: () => void
  handleCancelClick: () => void
  handleCancel: () => void
  handleDeleteProduct: (id: any) => void
  handleChange: (e: any) => void
  handleErrorMessage: (msg: string) => void
  isAdding: boolean
  styleRef: any
  partNameRef: any
  unitRef: any
  priceRef: any
  newProduct: any
  handleUpdateSuccess: (e: any) => void
  handleFilter: (filter1: any, filter2: any, filter3: any) => void
}

function RainwaterProduct(props: Product) {
  const {
    data,
    currentPage,
    totalPages,
    handleUpdateProduct,
    handleSave,
    editingId,
    editedData,
    handleSaveClick,
    handleInputChange,
    handlePrevPage,
    handleNextPage,
    handleCancelClick,
    handleCancel,
    handleDeleteProduct,
    handleChange,
    handleUpdateSuccess,
    handleErrorMessage,
    isAdding,
    styleRef,
    partNameRef,
    unitRef,
    priceRef,
    newProduct,
    handleFilter,
  } = props

  const {rainwaterCategories, rainwaterParts, rainwaterStyles, rainwaterUnitTypes} =
    useContext(AdminProductContext)
  const [saveData, setSaveData] = useState(isAdding ? newProduct : editedData)

  const [productNameFilter, setproductNameFilter] = useState('')
  const [gutterTypeFilter, setgutterTypeFilter] = useState('')
  const [colourFilter, setcolourFilter] = useState('')

  useEffect(() => {
    handleFilter(productNameFilter, gutterTypeFilter, colourFilter)
  }, [productNameFilter, gutterTypeFilter, colourFilter])

  useEffect(() => {
    setSaveData(editedData)
  }, [editedData])

  useEffect(() => {
    setSaveData(newProduct)
  }, [newProduct])

  const numRegex = /^(?:0|[1-9]\d*)(?:\.\d+)?$/

  const invalidRecord =
    (saveData?.productName || '') === '' ||
    (saveData?.gutterType || '') === '' ||
    (saveData?.colour || '') === ''

  return (
    <div style={{width: '85%'}} className='m-auto mt-4'>
      <table className='table table-hover product-table '>
        <thead className='thead-dark'>
          <tr>
            <th scope='col' className='align-middle text-center'>
              Item Number
            </th>
            <th scope='col' className='align-middle text-center'>
              Product Name
            </th>
            <th scope='col' className='align-middle text-center'>
              Category Name
            </th>
            <th scope='col' className='align-middle text-center'>
              Colour
            </th>
            <th scope='col' className='align-middle text-center'></th>
          </tr>
          <tr>
            <td className='align-middle text-center'></td>
            <td className='align-middle text-center'>
              <input
                type='text'
                value={gutterTypeFilter}
                onChange={(e) => setgutterTypeFilter(e.target.value)}
                className='filter-input'
              />
            </td>
            <td className='align-middle text-center'>
              <input
                type='text'
                value={productNameFilter}
                onChange={(e) => setproductNameFilter(e.target.value)}
                className='filter-input'
              />
            </td>
            <td className='align-middle text-center'>
              <input
                type='text'
                value={colourFilter}
                onChange={(e) => setcolourFilter(e.target.value)}
                className='filter-input'
              />
            </td>
            <td className='align-middle text-center'></td>
          </tr>
        </thead>
        <tbody>
          {data?.items?.length === 0 ? (
            <tr>
              <td colSpan={5} className='align-middle text-center'>
                There are no products to display!
              </td>
            </tr>
          ) : (
            data?.items?.map((data: any, index: number) => (
              <tr key={index}>
                <td className='align-middle text-center'>{data?.code}</td>
                <td className='align-middle text-center'>{data?.rainwaterStyleName}</td>
                <td className='align-middle text-center'>{data?.rainwaterPartName}</td>
                <td className='align-middle text-center'>{data?.rainwaterColourName}</td>
                <td className='align-middle text-center' style={{width: '250px'}}>
                  <div className='d-flex flex-row justify-content-center align-items-center w-100'>
                    <button
                      className='btn btn-primary btn-sm'
                      onClick={() => handleUpdateProduct(data?.id)}
                      style={{marginRight: 10}}
                    >
                      View
                    </button>
                    <button
                      className='btn btn-danger btn-sm'
                      onClick={() => handleDeleteProduct(data?.id)}
                    >
                      Delete
                    </button>
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      <div className='pagination d-flex align-items-center pb-4'>
        <button className='page-link' onClick={handlePrevPage} disabled={currentPage === 1}>
          <i className='bi bi-chevron-left'></i>
        </button>
        <div className='px-4'>{`Page ${currentPage} of ${totalPages}`}</div>
        <button
          className='page-link'
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
        >
          <i className='bi bi-chevron-right'></i>
        </button>
      </div>
    </div>
  )
}

export default RainwaterProduct
